import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import routes from './routes'

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'hash',
	base: store.getters.env.get('BASE_URL'),
	routes,
})

export default router;